export default __webpack_public_path__ + "static/media/Group -25.24cb5d68.svg";